import * as React from "react";
import Dropzone from "../common/Dropzone";
import { useCallback } from "react";
import { Box } from "@mui/system";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

export default function DocumentationFormUpload() {
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);
  const [file, setFile] = React.useState(null);
  const [multipartFile, setMultipartFile] = React.useState(null);

  React.useEffect(() => {
    if (multipartFile !== null) {
      const formData = new FormData();
      formData.append("file", multipartFile);

      fetch(
        webserver.protocol +
          "://" +
          webserver.host +
          ":" +
          webserver.port +
          "/settings/uploadDocumenationForm",
        { method: "PUT", credentials: "include", body: formData }
      )
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Error: " + response.status);
          }
          return response;
        })
        .then(() => {
          //   setRowss(prev => {
          //     let rowsCopy = JSON.parse(JSON.stringify(prev));
          //     rowsCopy[index].active = activity;
          //     return rowsCopy;
          //   });
          setGlobalMessage({
            globalMessage: "Dokumentation hochgeladen",
            severity: "success",
          });
        })
        .catch((error) => {
          setGlobalMessage({
            globalMessage: "Upload fehlgeschlagen",
            severity: "error",
          });
        });
    }
  }, [multipartFile]);

  const onDrop = useCallback((acceptedFiles) => {
    // Loop through accepted files
    acceptedFiles.map((file) => {
      setMultipartFile(file);
      // Initialize FileReader browser API
      const reader = new FileReader();
      // onload callback gets called after the reader reads the file data
      reader.onload = function (e) {
        // add the image into the state. Since FileReader reading process is asynchronous, its better to get the latest snapshot state (i.e., prevState) and update it.
        setFile([file.name, e.target.result]);
      };
      // Read the file as Data URL (since we accept only images)
      reader.readAsBinaryString(file);
      return file;
    });
  }, []);

  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <Box
        id="test1234"
        sx={{
          display: "flex",
          justifyContent: "center",
          width: "27%",
          height: "27%",
        }}
      >
        <Dropzone
          onDrop={onDrop}
          file={file}
          accept={{ "application/pdf": [".pdf"] }}
        />
      </Box>
    </Box>
  );
}
